///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Color } from "three";

import { IComponent } from "@inweb/viewer-core";
import type { Viewer } from "../Viewer";

export class BackgroundComponent implements IComponent {
  protected viewer: Viewer;
  protected backgroundColor: Color;

  constructor(viewer: Viewer) {
    this.viewer = viewer;

    this.backgroundColor = new Color(0xffffff);

    this.viewer.renderer.setClearColor(this.backgroundColor);
    this.viewer.scene.background = this.backgroundColor;
    this.viewer.addEventListener("optionschange", this.syncOptions);
  }

  dispose() {
    this.viewer.removeEventListener("optionschange", this.syncOptions);
    this.viewer.scene.background = undefined;
  }

  syncOptions = () => {
    this.backgroundColor.setHex(0xffffff);
    this.viewer.renderer.setClearColor(this.backgroundColor);
  };
}
